import { createComparingLifecycle } from "./lifecycle";
export function onWillUpdate(callback) {
    return createComparingLifecycle("componentWillUpdateCallback", callback);
}
export default onWillUpdate;

//# sourceMappingURL=onWillUpdate.js.map



//////////////////
// WEBPACK FOOTER
// ./~/reassemble/lib/onWillUpdate.js
// module id = 63
// module chunks = 0